import { Form, BaseModel, EntryTypes, Entry, Resource } from '@ngx-resource-toolkit/core';
import { anneeScolaireFetchOptions } from '../../shared/resource/select-options';
import { ProfesseurModel } from '../../professeur/models/professeur.model';
import { jourOptions } from '../../shared/resource/select-options-static';
import { inscriptionActionFetchOptions } from '../../shared/resource/select-options';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';

const cssTextPetit = {
    group: 'col-xs-6 col-sm-6 col-md-4 col-lg-3', // col-sm-6 col-md-4 col-lg-3
    label: 'col-xs-4 ',
    input: 'col-xs-8 ',
};
const cssTexte = {
    group: 'col-xs-12 col-sm-6 col-md-4 col-lg-3',
    label: 'col-xs-4 ', // col-sm-3 col-md-4
    input: 'col-xs-8 ', // col-sm-9 col-md-8
};
const cssRadio3 = {
    group: 'col-xs-12 col-sm-12 col-md-6 col-lg-4',
    label: 'col-xs-3 cours-radio',
    input: 'col-xs-3',
};
@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/cours',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'search': {
        // layout: ThreeColumnLayout,
    }
})
export class CoursRechercheModel extends BaseModel {

    // const TYPE_INDIVIDUEL = 1;
	// const TYPE_COLLECTIF = 2;
    // const TYPE_TOUS = 0;
    @Entry({
        'search': {
            type: EntryTypes.RADIO,
            label: 'Type de cours',
            css: cssRadio3,
            options: [{
                value: 0,
                label: 'Tous'
            }, {
                value: 1,
                label: 'Indiv.'
            }, {
                value: 2,
                label: 'Collec.'
            }],
            // layout: 'normal',
        }
    })
    typeCours: number = 0;

	// const IS_FICTIF_INDIFFERENT=0;
	// const IS_FICTIF_OUI=1;
    // const IS_FICTIF_NON=-1;
    @Entry({
        'search': {
            type: EntryTypes.RADIO,
            label: 'Fictif',
            css: cssRadio3,
            options: [{
                value: 0,
                label: 'Tous'
            }, {
                value: 1,
                label: 'Oui'
            }, {
                value: -1,
                label: 'Non'
            }],
            // layout: 'normal',
        }
    })
    fictif: number = 0;

    @Entry({
        'search': {
            type: EntryTypes.NUMBER,
            css: cssTextPetit,
            // layout: 'left',
            placeholder: 'Numéro',
            label: 'N°',
        },
    })
    id: number;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Année',
            css: cssTextPetit,
            fetchOptions: anneeScolaireFetchOptions,
            // layout: 'normal',
        }
    })
    anneeScolaire: number;




    @Entry({
        'search': {
            hidden: true,
        },
    })
    _explicitType: string = 'CoursSearchCriteria';


    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Type discipline',
            css: cssTexte,
        },
    })
    typeDiscipline: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Discipline',
            css: cssTexte,
            // layout: 'normal',
        }
    })
    discipline: any; // DisciplineModel;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Professeur',
            css: cssTexte,
            // layout: 'normal',
        },
    })
    professeur: ProfesseurModel;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Cycle',
            css: cssTexte,
            // layout: 'normal',
        }
    })
    cycleCours: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Niveau',
            css: cssTexte,
            // layout: 'normal',
        }
    })
    niveauCours: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Salle',
            css: cssTexte,
            // layout: 'normal',
        },
    })
    salle; // id de la sall: stringe

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Jour',
            css: cssTexte,
            options: [{value: null, label: 'Tous les jours'}, ...jourOptions],
            // layout: 'right',
        }
    })
    jour: number;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Statut inscription',
            css: cssTexte,
            hidden: true,
            // fetchOptions: inscriptionActionFetchOptions,
            // layout: 'right',
        }
    })
    codeAction: string;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Une ligne par élève'
            }],
            css: {
                group: 'col-xs-6 col-sm-6 col-md-4 col-lg-3',
            },
            // layout: 'right',
        }
    })
    uneLigneParEleve: boolean;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Non facturé'
            }],
            css: {
                group: 'col-xs-6 col-sm-6 col-md-4 col-lg-3',
            },
            // layout: 'right',
        }
    })
	isInscriptionNonFacturee: boolean;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Uniquement avec places disponibles'
            }],
            css: {
                group: 'col-xs-6 col-sm-6 col-md-4 col-lg-3',
            },
            // layout: 'right',
        }
    })
    isUniquementAvecPlacesDisponibles: boolean = false;

    

    heureDebut: string;
	minuteDebut: string;
	ordreHeure: string;
	duree: string;
	nbElevesMax: string;
    coursJumeaux: string;
    nbAnneesDansCycle: string;

    @Entry({
        'search': {
            hidden: true,
        }
    })
    dateDebut: string;
    @Entry({
        'search': {
            hidden: true,
        }
    })
    dateFin: string;

    constructor(data?) {
        super();
        if (!data) {
            data = {
                typeCours: 0,
                fictif: 0,
            };
        }
        Object.assign(this, data);
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/cours/models/cours-recherche.model.ts